/**
 * Reporta errores del flujo WSP sin importar MetricsCollectorService en el
 * top-level (evita ciclo store -> slice -> services -> MetricsCollectorService).
 */
let metricsCollectorPromise;

function getMetricsCollectorService() {
  if (!metricsCollectorPromise) {
    metricsCollectorPromise = import('@/services/MetricsCollectorService').then(
      (module) => module.default
    );
  }

  return metricsCollectorPromise;
}

export default function reportWhatsappFlowError(
  error,
  operation,
  contextPrefix
) {
  getMetricsCollectorService()
    .then((MetricsCollectorService) => {
      MetricsCollectorService.reportMessengerApiError(error, operation, {
        contextPrefix,
      });
    })
    .catch((reportError) => {
      console.warn(
        '[reportWhatsappFlowError] Failed to report error:',
        reportError
      );
    });
}
